import React, { useState, useEffect } from "react";
import { TbCurrentLocation } from "react-icons/tb";
import { IoEyeSharp } from 'react-icons/io5';
import { FaEyeSlash } from 'react-icons/fa';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, parse } from "date-fns";
import axios from "axios";
import { Navigate, useNavigate } from "react-router-dom";
import LocationPicker from "../LocationPicker/LocationPicker";

const RegCustomer = () => {
    const [customerMaster, setCustomerMaster] = useState({
        outletId: "",
        customerName: "",
        contactNo: "",
        password: "",
        contactEmail: "",
        birthDate: "",
        anniversaryDate: "",
        preferredAddress: "0",
        addresses: [
            {
                addressId: 0,
                addressType: "Home",
                addLine1: "",
                addLine2: "",
                nearBy: "",
                area: "",
                city: "",
                state: "",
                pincode: "",
                latitude: 0,
                longitude: 0,
            },
        ],
    });

    const API_BASE_URL = process.env.REACT_APP_API_KEY;
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordsMatch, setPasswordsMatch] = useState(true);

    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [showMap, setShowMap] = useState(false);

    localStorage.setItem("curLat", latitude)
    localStorage.setItem("curLon", longitude)

    const [errorMessage, setErrorMessage] = useState("***"); // State for error message
    const [areaMsg, setAreaMsg] = useState("***");
    const [passwordMsg, setPasswordMsg] = useState("Confirm Password Does not Match");
    const [addLn1, setAddLn1] = useState("***");
    const [nearbyMsg, setNearbyMsg] = useState("***");
    const [cityMsg, setCityMsg] = useState("***");
    const navigate = useNavigate();

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const getCurrentLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    console.log("Retrieved coordinates:", latitude, longitude);
                    setLatitude(latitude);
                    setLongitude(longitude);
                    fetchAddressFromCoordinates(latitude, longitude);
                },
                (error) => {
                    console.error("Geolocation error:", error);
                    let errorMessage = "Unable to fetch location.";
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            errorMessage = "Location permission denied. Please allow access.";
                            break;
                        case error.POSITION_UNAVAILABLE:
                            errorMessage = "Location information is unavailable.";
                            break;
                        case error.TIMEOUT:
                            errorMessage = "Location request timed out. Try again.";
                            break;
                        case error.UNKNOWN_ERROR:
                            errorMessage = "An unknown error occurred.";
                            break;
                    }
                    alert(errorMessage);
                },
                {
                    enableHighAccuracy: true,
                    timeout: 20000,
                    maximumAge: 0,
                }
            );
        } else {
            alert("Geolocation is not supported by this browser.");
        }
    };

    const fetchAddressFromCoordinates = async (lat, lon) => {
        try {
            const response = await axios.get(
                `https://nominatim.openstreetmap.org/reverse`,
                {
                    params: {
                        lat: lat,
                        lon: lon,
                        format: "json",
                    },
                }
            );

            if (response.data && response.data.address) {
                const { road, suburb, city, state, postcode } = response.data.address;

                setCustomerMaster((prev) => ({
                    ...prev,
                    addresses: [
                        {
                            area: suburb || "",
                            addLine1: road || "",
                            addLine2: "",
                            nearBy: "",
                            city: city || "",
                            state: state || "",
                            pincode: postcode || "",
                        },
                    ],
                }));
            } else {
                alert("Unable to fetch address. Try again.");
            }
        } catch (error) {
            console.error("Error fetching address:", error);
            alert("Error fetching address. Please try again later.");
        }
    };

    const searchLocation = () => {
        if (latitude !== null && longitude !== null) {
            window.open(`https://www.google.com/maps?q=${latitude},${longitude}`, "_blank");
        } else {
            alert("Please get the location first");
        }
    };

    const storedData = JSON.parse(localStorage.getItem("outletdataLocal")) || {};
    let outletId, outletlogo, outletName;
    if (Array.isArray(storedData) && storedData.length > 0) {
        outletId = storedData[0].outletId;
        outletlogo = storedData[0].outletlogo;
        outletName = storedData[0].outletName;
    } else if (storedData && typeof storedData === "object") {
        outletId = storedData.outletId;
        outletlogo = storedData.outletlogo;
        outletName = storedData.outletName;
    }




    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setCustomerMaster((prevState) => ({
            ...prevState,
            outletId: outletId,
            [name]: value,
        }));

        // Temporary error storage
        let tempErrorMessage = "";

        // Password validation
        if (name === "password") {
            setPasswordsMatch(value === confirmPassword);
            tempErrorMessage = value === confirmPassword ? "" : "Confirm Password does not match";
            setPasswordMsg(tempErrorMessage)
        }

        // Customer Name validation
        if (name === "customerName") {
            if (value.trim().length === 0) {
                tempErrorMessage = "This field is required";
            } else if (value.trim().length < 3) {
                tempErrorMessage = "Minimum 3 characters required";
            }
            setErrorMessage(tempErrorMessage);
        }


        // Update error message state
    };





    const handleConfirmPasswordChange = (e) => {
        const { value } = e.target;
        setConfirmPassword(value);

        // Validate confirm password with the entered password
        if (value === customerMaster.password) {
            setPasswordsMatch(true);
            setPasswordMsg(""); // Clear error if matched

        }


        else {
            setPasswordsMatch(false);
            setPasswordMsg("Confirm Password does not match"); // Show error
        }
    };



    // Pre-fill the password with the last 5 digits of contact number
    useEffect(() => {
        if (customerMaster.contactNo) {
            const lastFiveDigits = customerMaster.contactNo.slice(-5);
            setCustomerMaster((prevState) => ({
                ...prevState,
                password: lastFiveDigits,
            }));

        }

    }, [customerMaster.contactNo]);


    const handleAddressChange = (e) => {
        const { name, value } = e.target;
        setCustomerMaster((prevState) => ({
            ...prevState,
            addresses: [
                {
                    ...prevState.addresses[0],
                    [name]: value,
                    latitude: latitude || prevState.addresses[0].latitude,
                    longitude: longitude || prevState.addresses[0].longitude,
                },
            ],
        }));

        // Address area validation (Ensure addresses array exists)
        if (name === "addLine1") {
            if (value.trim().length === 0) {
                setAddLn1("This field is required");
            } else setAddLn1("");


        }

        if (name === "area") {
            if (value.trim().length === 0) {
                setAreaMsg("This field is required");
            } else setAreaMsg("");


        }

        if (name === "nearBy") {
            if (value.trim().length === 0) {
                setNearbyMsg("This field is required");
            } else setNearbyMsg("");


        }

        if (name === "city") {
            if (value.trim().length === 0) {
                setCityMsg("This field is required");
            } else setCityMsg("");


        }



    };


    const RegisterCustomer = async () => {

        setErrorMessage("");
        setAreaMsg("");
        setAddLn1("");
        setNearbyMsg("");
        setCityMsg("");
        setPasswordMsg("");

        let isValid = true;

        // Validation checks

        if (!customerMaster.customerName) {
            setErrorMessage("Customer Name is required");
            isValid = false;
        }
        if (!customerMaster.password) {
            setPasswordMsg("Password is required");
            isValid = false;
        }

        if (customerMaster.password !== confirmPassword) {
            setPasswordMsg("Confirm Password does not match");
            isValid = false;
        }

        if (!customerMaster.addresses[0].area) {
            setAreaMsg("Area is required");
            isValid = false;
        }

        if (!customerMaster.addresses[0].addLine1) {
            setAddLn1("Address Line 1 is required");
            isValid = false;
        }

        if (!customerMaster.addresses[0].nearBy) {
            setNearbyMsg("Nearby landmark is required");
            isValid = false;
        }

        if (!customerMaster.addresses[0].city) {
            setCityMsg("City is required");
            isValid = false;
        }

        // If any validation fails, stop the submission
        if (!isValid) {
            return;
        }
        const cleanedData = {
            ...customerMaster,
            birthDate: customerMaster.birthDate === "1900-12-31" ? "" : customerMaster.birthDate,
            anniversaryDate: customerMaster.anniversaryDate === "1900-12-31" ? "" : customerMaster.anniversaryDate,
        };


        try {

            const response = await axios.post(`${API_BASE_URL}CustomerMaster`, cleanedData);
            console.log("Registration Successful !!");
            const loginDetails = {
                customerId: response.data.customerId,
                preferredAddress: response.data.preferredAddress,
                customerName: response.data.customerName
            };

            // Save to local storage
            localStorage.setItem("loginDetails", JSON.stringify(loginDetails));

            navigate("/QrCartItems")
        } catch (error) {
            console.log("Error posting data", error);
        }
    };


    return (
        <div className="container">
            <div className="row">
                <nav className="navbar navbar-light bg-light shadow-sm bg-body rounded">
                    <div className="container-fluid">
                        <a className="navbar-brand" href="#">
                            <img
                                src={outletlogo}
                                alt=""
                                width={60}
                                height={40}
                                className="d-inline-block align-text-center me-2 img-fluid"
                            />
                            <strong>{outletName}</strong>
                        </a>
                    </div>
                </nav>

                <div className="col-md-12 mt-2 border">
                    {/* Customer Information Fields */}
                    <div className="row">
                        <div className="col-10">
                            {errorMessage && <small className="text-danger p-0">{errorMessage}</small>}
                            <input
                                style={{ height: "30px" }}
                                required
                                type="text"
                                className="form-control"
                                placeholder="Enter Name"
                                name="customerName"
                                value={customerMaster.customerName}
                                onChange={handleInputChange}
                            />
                            {/* Error Message */}

                        </div>
                    </div>

                    {/* Contact Fields */}
                    <div className="row">
                        <div className="col-md-12 d-flex justify-content-between mb-1 mt-1">
                            <div className="col-md-4 me-2">
                                <input
                                    type="tel"  // opens numeric pad on mobile
                                    pattern="[0-9]{10}"  // requires exactly 10 digits
                                    maxLength={10}  // prevents typing more than 10 digits
                                    className="form-control"

                                    placeholder="Mobile No"
                                    name="contactNo"
                                    value={customerMaster.contactNo}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-md-4">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Email Id"
                                    name="contactEmail"
                                    value={customerMaster.contactEmail}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 d-flex">
                            {/* Birth Date Field */}

                            <div className="col-md-4 me-2">
                                <label>Birth Date</label>
                                <input type="date"
                                    placeholder="Birth Date"
                                    name="birthDate"
                                    value={customerMaster.birthDate || "1900-12-31"}
                                    onChange={handleInputChange}
                                />
                            </div>

                            {/* Anniversary Date Field */}
                            <div className="col-md-4">
                                <label>Annivarsary Date</label>
                                <input type="date"
                                    name="anniversaryDate"
                                    placeholder="Annivarsary Date"
                                    value={customerMaster.anniversaryDate || "1900-12-31"}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>

                        <p className="text-primary text-center">Fill these dates to get exclusive offers!</p>
                    </div>



                    {/* Password Fields */}
                    <div className="row">
                        <div className="col-md-12 d-flex justify-content-between mb-2">
                            <div className="col-md-4 me-2 position-relative">
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    className="form-control"
                                    placeholder="Enter Password"
                                    name="password"
                                    value={customerMaster.password}
                                    onChange={handleInputChange}
                                />
                                <span
                                    className="position-absolute top-50 end-0 translate-middle-y pe-3"
                                    onClick={togglePasswordVisibility}
                                    style={{ cursor: 'pointer' }}
                                >
                                    {showPassword ? <IoEyeSharp /> : <FaEyeSlash />}
                                </span>
                            </div>
                            <div className="col-md-4 position-relative">
                                <input
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    className="form-control"
                                    placeholder="Confirm Password"
                                    value={confirmPassword}
                                    onChange={handleConfirmPasswordChange}
                                    style={{
                                        borderColor: passwordsMatch ? 'green' : 'red',
                                        transition: 'border-color 0.3s',
                                    }}
                                />
                                <span
                                    className="position-absolute top-50 end-0 translate-middle-y pe-3"
                                    onClick={toggleConfirmPasswordVisibility}
                                    style={{ cursor: 'pointer' }}
                                >
                                    {showConfirmPassword ? <IoEyeSharp /> : <FaEyeSlash />}
                                </span>
                                {/* Error Message */}

                            </div>

                        </div>
                    </div>
                    {!passwordsMatch && passwordMsg && (
                        <small className="text-danger">{passwordMsg}</small>
                    )}

                    {/* Location Fields */}
                    <div className="row justify-content-center">
                        <div className="col-md-5 col-sm-6 col-10 mb-3">
                            <div className="d-flex align-items-center" style={{ maxWidth: "400px" }}>
                                <input

                                    type="text"
                                    className="form-control"
                                    value={latitude !== null && longitude !== null ? `${latitude}, ${longitude}` : ""}
                                    placeholder="Search Current location"
                                    readOnly
                                />
                                <button className="btn btn-outline-primary ms-2" onClick={getCurrentLocation}>
                                    <TbCurrentLocation size={24} />
                                </button>
                                <button className="btn btn-primary ms-2"
                                    style={{ width: "250px" }}
                                    onClick={() => setShowMap(true)}>Open Map</button>
                            </div>
                        </div>
                    </div>





                    {showMap && (
                        <div style={{ marginTop: "20px" }}>
                            <LocationPicker
                                latitude={latitude}
                                longitude={longitude}
                                setLatitude={setLatitude}
                                setLongitude={setLongitude}
                                fetchAddressFromCoordinates={fetchAddressFromCoordinates}
                            />
                            <button style={{ marginTop: "10px" }} onClick={() => setShowMap(false)}>
                                Close Map
                            </button>
                        </div>
                    )}

                    {/* Address Fields */}
                    <div className="row justify-content-center">
                        <div className="col-md-5 col-sm-6 col-10">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Area"
                                name="area"
                                value={customerMaster.addresses[0].area}
                                onChange={handleAddressChange}
                            />
                            {areaMsg && <small className="text-danger">{areaMsg}</small>}
                        </div>
                        <div className="col-md-5 col-sm-6 col-10">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Address Line 1"
                                name="addLine1"
                                value={customerMaster.addresses[0].addLine1}
                                onChange={handleAddressChange}
                            />
                            {addLn1 && <small className="text-danger">{addLn1}</small>}
                        </div>
                    </div>

                    {/* More Address Fields */}
                    <div className="row justify-content-center">
                        <div className="col-md-5 col-sm-6 col-10 mb-1">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Address Line 2"
                                name="addLine2"
                                value={customerMaster.addresses[0].addLine2}
                                onChange={handleAddressChange}
                            />
                        </div>
                        <div className="col-md-5 col-sm-6 col-10">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Near By"
                                name="nearBy"
                                value={customerMaster.addresses[0].nearBy}
                                onChange={handleAddressChange}
                            />
                            {nearbyMsg && <small className="text-danger">{nearbyMsg}</small>}
                        </div>
                    </div>

                    {/* City, State, Pincode Fields */}
                    <div className="d-flex justify-content-center">
                        <div className="col-md-5 me-1">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="City"
                                name="city"
                                value={customerMaster.addresses[0].city}
                                onChange={handleAddressChange}
                            />
                            {cityMsg && <small className="text-danger">{cityMsg}</small>}
                        </div>
                        <div className="col-md-5">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="State"
                                name="state"
                                value={customerMaster.addresses[0].state}
                                onChange={handleAddressChange}
                            />
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-md-5 col-sm-6 col-10 mb-3">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="PinCode"
                                name="pincode"
                                value={customerMaster.addresses[0].pincode}
                                onChange={handleAddressChange}
                            />
                        </div>
                    </div>


                    {/* Submit Button */}
                    <div className="row justify-content-center">
                        <div className="col-md-12 col-sm-6 col-10 mb-3 d-flex justify-content-center">
                            <button className="btn btn-outline-primary p-1" onClick={RegisterCustomer}>
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegCustomer;
